import React from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import CrmButton from "../ui/CrmButton";
import { CRM } from "../../../constants/testIds/crm";

/**
 * The capture form's one-line embed (design §E.4: "Copy embed code" + a read-only code
 * block). Copying never depends on `document.execCommand`: a browser that refuses the
 * Clipboard API (no permission, insecure origin) leaves the snippet selectable on screen
 * instead of a false "copied" toast.
 */
export default function EmbedCodeBlock({ snippet }) {
  const t = useT("crm");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
    } catch {
      return;
    }
    toast.success(t("forms.copied"));
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-eh-ink">{t("forms.snippet")}</span>
        <CrmButton variant="outline" size="sm" onClick={copy} data-testid={CRM.formsCopy}>
          <Copy size={14} aria-hidden="true" /> {t("forms.copyEmbed")}
        </CrmButton>
      </div>
      <pre data-testid={CRM.formsSnippet} className="overflow-x-auto rounded-2xl bg-eh-cream px-4 py-3 text-xs text-eh-ink">
        <code>{snippet}</code>
      </pre>
    </div>
  );
}
